import classNames from 'classnames'
import { Ref } from 'react'

import { TextField, TextFieldNoteProps, TextFieldProps } from '../text-field/text-field.js'

export type TextAreaNoteProps = TextFieldNoteProps

export interface TextAreaProps extends Omit<
    TextFieldProps,
    'as' | 'inputRef' | 'prefix' | 'suffix' | 'type'
> {
    inputRef?: Ref<HTMLTextAreaElement>
    note?: TextAreaNoteProps
}

export const TextArea = (props: TextAreaProps) => (
    <TextField
        as="textarea"
        className={classNames('text-area', props.className)}
        labelClass={props.labelClass}
        label={props.label}
        value={props.value}
        onChange={props.onChange}
        placeholder={props.placeholder}
        isRequired={props.isRequired}
        isDisabled={props.isDisabled}
        textAreaRef={props.inputRef}
        note={props.note}
    />
)
